import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-spcod/spcoddeliveryorder/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/api/park-spcod/spcoddeliveryorder/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-spcod/spcoddeliveryorder/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-spcod/spcoddeliveryorder/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/park-spcod/spcoddeliveryorder/createorder',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-spcod/spcoddeliveryorder/submit',
    method: 'post',
    data: row
  })
}

//{addrTag:地址标签,bizType:XPS快递,bizId:当前ID,deliveryTitle:标题,memo:}
export const createOrder = (row) => {
  return request({
    url: '/api/park-spcod/spcoddeliveryorder/createorder',
    method: 'post',
    data: row
  })
}

//订单分配
export const assignOrder = (row) => {
  return request({
    url: '/api/park-spcod/spcoddeliveryorder/assignorder',
    method: 'post',
    data: row
  })
}
